export default class DOMQuery {
    constructor(identifier, root = document) {
        this._identifier = identifier;
        this._nodeList = root.querySelectorAll(identifier);
    }
    get length() {
        return this._nodeList.length;
    }
    get first() {
        if (this._nodeList.length === 0) {
            return null;
        }
        return this.toArray()[0];
    }
    firstOrFail() {
        const e = this.first;
        if (!e) {
            throw new Error(`Element not found: "${this._identifier}"`);
        }
        return e;
    }
    toArray() {
        return this.all();
    }
    all() {
        return Array.from(this._nodeList).map(n => n);
    }
}
